import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_REVIEWS_SAGA } from "../sagaTypes";
import { loaderAction, paginationAction, setReviewsAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_reviews`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetReviews(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('page', args?.data?.page || 1);
        formData.append('date_from', args.data?.date_from || '');
        formData.append('date_to', args.data?.date_to || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сохраняем список отзывов за период
            yield put(setReviewsAction(response.reviews));
            // Сохраняем пагинацию
            yield put(paginationAction(response.pagination));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetReviews() {
    yield takeLatest(GET_REVIEWS_SAGA, workerGetReviews);
}